export const normalizeLanguage = (value?: string | null): string => {
  if (!value) return "en";
  return value.split("-")[0].toLowerCase();
};
